import React from 'react'
import './css/socials.css'
import github from './icons/github.png'
import linkedin from './icons/linkedin.png'
import instagram from './icons/instagram.png'
import gmail from './icons/gmail.png'
function Socials() {
    return (
        <div className='right-section socials background'>
            <h1>Connect to <span className='me'>me</span></h1>
            <div className='icons'>
                <a href='https://github.com/akash-kamat' rel="noreferrer" target='_blank'><img src={github} alt="github" /></a>
                <a href='https://linkedin.com/in/akash-kamat' rel="noreferrer" target='_blank'><img src={linkedin} alt="linkedin" /></a>
                <a href='mailto: akash.kamat.10@gmail.com'><img src={gmail} alt="gmail" /></a>
                <a href='https://instagram.com/_akash.png' rel="noreferrer" target='_blank'><img src={instagram} alt="instagram" /></a>
            </div>
        </div>
    )
}

export default Socials